
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.2 0h9.6A3.2 3.2 0 0116 3.2v9.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 12.8V3.2A3.2 3.2 0 013.2 0zm5.4 8.6h2.6a.6.6 0 100-1.2H8.6V4.8a.6.6 0 00-1.2 0v2.6H4.8a.6.6 0 000 1.2h2.6v2.6a.6.6 0 101.2 0V8.6z","fill":"#fff"}})])
          )
        }
      }
    